const HomeIcon = () => {
    return (
        <i className="fa-solid fa-house"></i>
    );
}

export default HomeIcon;